// src/config.js

const url = {
  login: '/api/public/login',
  get_all_students: '/api/v1/admin/get-students',
  admin_create_student: '/api/v1/admin/create-student',
  create_teachers: '/api/v1/admin/create-teachers',
  get_all_teachers: '/api/v1/admin/get-teachers',
  master_qualifications: '/api/public/qualifications',
  public_tenants: '/api/public/tenants',
  logout: '/api/v1/general/logout',
  master_durations: '/api/public/durations',
  master_massarats: '/api/public/massarat',
  public_quran_parts: '/api/public/quran-parts',
  activate_student: '/api/v1/admin/activate-student/',
  dashboard: '/api/v1/admin/get-dashboard',
  master_sessions: '/api/v1/admin/get-teacher-sessions',
  students_sessions_report: '/api/v1/admin/students_sessions_report/',
  summary_session_report: '/api/v1/admin/summary-session-report/',
  daily_student_report: '/api/v1/admin/daily_student_report/',
  master_regions: '/api/v1/admin/regions',
  master_Addregion: '/api/v1/admin/Addregion',
  Add_athan_time: '/api/v1/admin/Addathan-time/',
  Delete_athan_time: '/api/v1/admin/Deletethan-time/',
  master_athan_time: '/api/v1/admin/athan-time/',
  get_prayer_time_from_aladhan: '/api/v1/admin/athan-time/', // {regionId}/prayer-time/{prayerName}
  edit_athan_time: '/api/v1/admin/edit-athan-time/',
  withdrawalStatus: '/api/v1/admin/enable-disable-teacher-withdraw/student/',
  userStatus: '/api/v1/admin/enable-disable-user-login/user/',
  changePassword: '/api/v1/admin/change-password/user/',
  reports: '/api/v1/admin/get-report/session/',
  sessions_report: '/api/v1/admin/get-sessions-report/',
  get_students_sessions: '/api/v1/admin/get-all-students/',
  get_students_download: '/api/v1/admin/get-download-url/',
  get_config: '/api/public/all-config-values',
  change_config: '/api/v1/admin/change/config',
  create_admin: '/api/v1/admin/create-admin',
  get_all_admins: `/api/v1/admin/get-admins`,    
  delete_admin:   `/api/v1/admin/delete-admin/`, 
  update_admin:   `/api/v1/admin/update-admin/`,
  changeStatus:   `/api/v1/admin/Tchange_Status/`,
  send_chat: '/api/v1/chat/send-messages',
  change_teacher_info: '/api/v1/admin/change_teacher_info/',
  update_student_details: '/api/v1/admin/change_user_info/',
  teacher_availability: '/api/v1/admin/teacher-availability/',
  manual_prayer_time_update: '/api/v1/admin/manual-prayer-time-update',
  edit_session: '/api/v1/admin/edit-session/',
  delete_session: '/api/v1/admin/delete-session/',
  check_teacher_availability: '/api/v1/admin/teacher-availability',
  teacher_monthly_schedule: '/api/v1/admin/teacher-monthly-schedule',
  student_monthly_schedule: '/api/v1/admin/student-monthly-schedule',

  trigger_daily_tracker: '/api/v1/admin/trigger-daily-tracker',
  get_enabled_students: '/api/v1/admin/get-enabled-students',
  reports_generate: '/api/v1/admin/reports/generate',
  reports_export: '/api/v1/admin/reports/export',
  reports_student_progress: '/api/v1/admin/reports/student-progress',
  reports_student_attendance: '/api/v1/admin/reports/student-attendance',
  reports_session_utilization: '/api/v1/admin/reports/session-utilization',
  reports_teacher_workload: '/api/v1/admin/reports/teacher-workload',
  reports_regional_performance: '/api/v1/admin/reports/regional-performance',
  get_teacher_sessions: '/api/v1/admin/get-teacher-sessions',
  get_students: '/api/v1/admin/get-students',
  get_teachers: '/api/v1/admin/get-teachers',
  regions: '/api/v1/admin/regions',
  
  // Audit Logs
  audit_logs: '/api/v1/admin/audit-logs',
  
  // Organizations
  organizations: '/api/v1/organizations',
  organizations_search: '/api/v1/organizations/search',
  
  // Teacher Response Report
  teacher_response_report: '/api/v1/admin/teacher-response-report',
  teacher_response_report_pdf: '/api/v1/admin/teacher-response-report/pdf',
  teacher_response_report_excel: '/api/v1/admin/teacher-response-report/excel',
  teacher_response_report_csv: '/api/v1/admin/teacher-response-report/export-csv',
  daily_tracker_details: '/api/v1/admin/daily-tracker/',
  update_daily_tracker: '/api/v1/admin/daily-tracker/',
  

  
  // Admin Messages
  admin_messages: '/api/admin-messages',
  admin_messages_active: '/api/admin-messages/active',
  admin_messages_welcome: '/api/admin-messages/welcome',
  admin_messages_toggle: '/api/admin-messages/toggle',

  // Live Sessions (Now)
  admin_live_sessions: '/api/v1/admin/live-sessions',
  admin_live_sessions_join: '/api/v1/admin/live-sessions/join',
  admin_live_sessions_leave: '/api/v1/admin/live-sessions/leave',
  admin_live_sessions_audit: '/api/v1/admin/live-sessions/audit',

  // Public Circles Management
  admin_public_circles: '/api/v1/admin/public-circles',
  admin_public_circles_move_student: '/api/v1/admin/public-circles/move-student',
  admin_public_circles_attendance_logs: '/api/v1/admin/public-circles/attendance-logs',
  admin_public_circles_daily_chat_logs: '/api/v1/admin/public-circles/daily-chat-logs',
  
  // Prayer Configuration Management (Simplified)
  update_prayer_configurations: '/api/v1/admin/update-prayer-configurations/',
  
  // Session Time Management
  get_session_times: '/api/v1/admin/session-times/',
  create_session_time: '/api/v1/admin/session-time',
  delete_session_time: '/api/v1/admin/session-time/',
  get_session_time_students: '/api/v1/admin/session-time/',
  get_available_session_times_for_move: '/api/v1/admin/session-time/',
  move_student_to_session: '/api/v1/admin/students/',
  reorder_session_slot: '/api/v1/admin/reorder-session-slot',
  
  // Student Sessions Management
  student_sessions: '/api/v1/admin/student-sessions',
  student_sessions_comprehensive: '/api/v1/admin/student-sessions/comprehensive',
  student_sessions_by_id: '/api/v1/admin/student-sessions/',
  student_sessions_options_students: '/api/v1/admin/student-sessions/options/students',
  student_sessions_options_available_students: '/api/v1/admin/student-sessions/options/available-students',
  student_sessions_options_teacher_sessions: '/api/v1/admin/student-sessions/options/teacher-sessions',
  student_sessions_options_session_times: '/api/v1/admin/student-sessions/options/session-times/',
  admin_booking_teachers: '/api/v1/admin/student-booking/teachers',
  admin_booking_students: '/api/v1/admin/student-booking/students',
  admin_booking_teacher_slots: '/api/v1/admin/student-booking/teacher/',
  admin_booking_book: '/api/v1/admin/student-booking/book',
  admin_booking_bookings: '/api/v1/admin/student-booking/bookings',

  // Tenants Management (Super Admin)
  tenants_list: '/api/v1/admin/tenants',
  tenants_show: '/api/v1/admin/tenants/',
  tenants_create: '/api/v1/admin/tenants',
  tenants_update: '/api/v1/admin/tenants/',
  tenants_delete: '/api/v1/admin/tenants/',
  tenants_statistics: '/api/v1/admin/tenants/',

  // General Managers Management (Super Admin)
  general_managers_list: '/api/v1/admin/general-managers',
  general_managers_show: '/api/v1/admin/general-managers/',
  general_managers_create: '/api/v1/admin/general-managers',
  general_managers_update: '/api/v1/admin/general-managers/',
  general_managers_delete: '/api/v1/admin/general-managers/',
  general_managers_disable: '/api/v1/admin/general-managers/',
  general_managers_enable: '/api/v1/admin/general-managers/',

  // Qualifications Management (Admin)
  qualifications_list: '/api/v1/admin/qualifications',
  qualifications_show: '/api/v1/admin/qualifications/',
  qualifications_create: '/api/v1/admin/qualifications',
  qualifications_update: '/api/v1/admin/qualifications/',
  qualifications_delete: '/api/v1/admin/qualifications/',

  // Durations Management (Admin)
  durations_list: '/api/v1/admin/durations',
  durations_show: '/api/v1/admin/durations/',
  durations_create: '/api/v1/admin/durations',
  durations_update: '/api/v1/admin/durations/',
  durations_delete: '/api/v1/admin/durations/',

  // Massarats Management (Admin)
  massarats_list: '/api/v1/admin/massarats',
  massarats_show: '/api/v1/admin/massarats/',
  massarats_create: '/api/v1/admin/massarats',
  massarats_update: '/api/v1/admin/massarats/',
  massarats_delete: '/api/v1/admin/massarats/',

  // Regions Management (Admin)
  regions_list: '/api/v1/admin/regions-management',
  regions_show: '/api/v1/admin/regions-management/',
  regions_create: '/api/v1/admin/regions-management',
  regions_update: '/api/v1/admin/regions-management/',
  regions_delete: '/api/v1/admin/regions-management/',

  // Athan Times Management (Admin)
  athan_times_list: '/api/v1/admin/athan-times-management',
  athan_times_show: '/api/v1/admin/athan-times-management/',
  athan_times_create: '/api/v1/admin/athan-times-management',
  athan_times_update: '/api/v1/admin/athan-times-management/',
  athan_times_delete: '/api/v1/admin/athan-times-management/',

  // Goals Management (Admin)
  goals_list: '/api/v1/admin/goals-management',
  goals_show: '/api/v1/admin/goals-management/',
  goals_create: '/api/v1/admin/goals-management',
  goals_update: '/api/v1/admin/goals-management/',
  goals_delete: '/api/v1/admin/goals-management/',
  
  // Teacher Schedules Management (Admin)
  teacher_schedules_list: '/api/v1/admin/teachers',
  teacher_schedules_by_day: '/api/v1/admin/teachers',
  teacher_schedules_show: '/api/v1/admin/teachers',
  teacher_schedules_create: '/api/v1/admin/teachers',
  teacher_schedules_update: '/api/v1/admin/teachers',
  teacher_schedules_delete: '/api/v1/admin/teachers',
  
  // Peer Review Reports (Admin)
  peer_review_report: '/api/v1/admin/peer-review/report',
  peer_review_recording: '/api/v1/admin/peer-review/recording',
  
  // Student Status Management
  update_student_status: '/api/v1/admin/students',
  
  // Super Admin General Report
  super_admin_general_report: '/api/v1/admin/super-admin/general-report',
  get_tenants: '/api/v1/admin/tenants',
  
  // Permissions System
  permission_groups_list: '/api/v1/admin/permission-groups',
  permission_groups_show: '/api/v1/admin/permission-groups/',
  permission_groups_create: '/api/v1/admin/permission-groups',
  permission_groups_update: '/api/v1/admin/permission-groups/',
  permission_groups_delete: '/api/v1/admin/permission-groups/',
  permission_groups_assign_permissions: '/api/v1/admin/permission-groups/',
  permission_groups_assign_user: '/api/v1/admin/permission-groups/',
  permission_groups_remove_user: '/api/v1/admin/permission-groups/',
  
  permissions_me: '/api/v1/admin/permissions/me',
  permissions_user: '/api/v1/admin/permissions/user/',
  permissions_user_groups: '/api/v1/admin/permissions/user/',
  permissions_check: '/api/v1/admin/permissions/check',
  
  pages_list: '/api/v1/admin/pages',
  pages_show: '/api/v1/admin/pages/',
  pages_sync: '/api/v1/admin/pages/sync',

  // Support Tickets
  support_tickets_create: '/api/v1/support-tickets',
  support_tickets_my: '/api/v1/support-tickets/me',
  support_tickets_show: '/api/v1/support-tickets/', // + {id}
  support_tickets_add_message: '/api/v1/support-tickets/', // + {id}/messages
  support_tickets_admin_list: '/api/v1/admin/support-tickets',
  support_tickets_admin_reply: '/api/v1/admin/support-tickets/', // + {id}/reply
  support_tickets_admin_status: '/api/v1/admin/support-tickets/', // + {id}/status

  // Iqra Module (isolated)
  iqra_schedules: '/api/v1/admin/iqra/schedules',
  iqra_days: '/api/v1/admin/iqra/days',
  iqra_students: '/api/v1/admin/iqra/students',
  iqra_students_with_active_subscriptions: '/api/v1/admin/iqra/students-with-active-subscriptions',
  iqra_slot_teachers: '/api/v1/admin/iqra/slot-teachers',
  iqra_student_slot_enrollments: '/api/v1/admin/iqra/student-slot-enrollments',
  iqra_student_slot_enrollments_bulk_by_teacher: '/api/v1/admin/iqra/student-slot-enrollments/bulk-by-teacher',
  iqra_student_slot_enrollments_bulk_by_slot_group: '/api/v1/admin/iqra/student-slot-enrollments/bulk-by-slot-group',
  iqra_subscription_packages: '/api/v1/admin/iqra/subscription-packages',
  iqra_student_subscriptions: '/api/v1/admin/iqra/student-subscriptions',
  iqra_subscription_payment_intent: '/api/v1/admin/iqra/subscriptions/payment-intent',
  iqra_prayer_times: '/api/v1/admin/iqra/prayer-times',
  iqra_prayer_times_sync_status: '/api/v1/admin/iqra/prayer-times/sync-status',
  iqra_prayer_times_resync: '/api/v1/admin/iqra/prayer-times/resync',
};

export default url;
